import { Injectable } from '@angular/core';
import { ChecklistEntity } from '../../domain/entities/checklist.entity';
import { ChecklistStepEntity } from '../../domain/entities/checklist-step.entity';
import { ChecklistListItemEntity } from '../../domain/entities/checklist-list-item.entity';
import { ChecklistResponseDto } from '../dtos/checklist-response.dto';
import { ChecklistStepResponseDto } from '../dtos/checklist-step-response.dto';
import { ChecklistListItemResponseDto } from '../dtos/checklist-list-item-response.dto';

@Injectable({ providedIn: 'root' })
export class ChecklistMapper {
  toDomain(dto: ChecklistResponseDto): ChecklistEntity {
    return {
      id: dto.id,
      displayOnCases: dto.displayOnCases,
      steps: this.toStepDomainArray(dto.steps),
    };
  }

  toStepDomain(dto: ChecklistStepResponseDto): ChecklistStepEntity {
    return {
      id: dto.id,
      description: dto.description,
      displayOrder: dto.displayOrder,
    };
  }

  toStepDomainArray(dtos: ChecklistStepResponseDto[]): ChecklistStepEntity[] {
    return dtos.map((dto) => this.toStepDomain(dto));
  }

  toListItemDomain(dto: ChecklistListItemResponseDto): ChecklistListItemEntity {
    return new ChecklistListItemEntity(
      dto.id,
      dto.caseTypeId,
      dto.caseTypeName,
      dto.stepCount,
      dto.displayOnCases,
      dto.updatedOn,
    );
  }

  toListItemDomainArray(dtos: ChecklistListItemResponseDto[]): ChecklistListItemEntity[] {
    return dtos.map((dto) => this.toListItemDomain(dto));
  }
}
